var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUserProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.59998 13.675C1.59998 11.158 3.70283 9.11756 7.99997 9.11756C12.2971 9.11756 14.4 11.158 14.4 13.675C14.4 14.0755 14.1078 14.4001 13.7474 14.4001H2.25252C1.89213 14.4001 1.59998 14.0755 1.59998 13.675Z",
    stroke: "#455468",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4 4.0001C10.4 5.32558 9.32546 6.4001 7.99997 6.4001C6.67449 6.4001 5.59998 5.32558 5.59998 4.0001C5.59998 2.67461 6.67449 1.6001 7.99997 1.6001C9.32546 1.6001 10.4 2.67461 10.4 4.0001Z",
    stroke: "#455468",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserProfile);
export default __webpack_public_path__ + "static/media/IconUserProfile.cbcb07f9655b3ef1a8b5894278c9a710.svg";
export { ForwardRef as ReactComponent };